import type { SxProps, Theme } from '@mui/material'

export const zoomPercentageTextSx = (showZoomLevel: boolean): SxProps<Theme> => ({
  color: showZoomLevel ? 'primary.main' : 'text.secondary',
  transition: 'color 0.3s ease-in-out',
  fontWeight: 500,
  minWidth: 40,
  textAlign: 'center',
})

export const zoomControlIconButtonSx: SxProps<Theme> = {
  color: 'text.secondary',
  '&:hover': {
    backgroundColor: 'transparent',
    color: 'primary.main',
  },
}
